/**
 * manager-global-event-bus.js
 * Sistema de eventos global para comunicação desacoplada entre managers.
 *
 * Disponível como window.eventBus antes de qualquer outro manager.
 *
 * API:
 *   const unsub = window.eventBus.on('event', callback) → retorna função de cleanup
 *   window.eventBus.off('event', callback)
 *   window.eventBus.emit('event', data)
 */

class EventBus {
  constructor() {
    this._listeners = {};
  }

  /**
   * Registra um listener para um evento.
   * @param {string} event
   * @param {Function} callback
   * @returns {Function} Função para remover o listener
   */
  on(event, callback) {
    if (!this._listeners[event]) {
      this._listeners[event] = [];
    }
    this._listeners[event].push(callback);
    return () => this.off(event, callback);
  }

  /**
   * Remove um listener.
   * @param {string} event
   * @param {Function} callback
   */
  off(event, callback) {
    if (!this._listeners[event]) return;
    this._listeners[event] = this._listeners[event].filter(cb => cb !== callback);
  }

  /**
   * Emite um evento para todos os listeners registrados.
   * @param {string} event
   * @param {*} data
   */
  emit(event, data) {
    if (!this._listeners[event]) return;
    this._listeners[event].forEach(cb => cb(data));
  }
}

window.eventBus = new EventBus();